export default "__VITE_ASSET__CEvZZFKG__"